import io from 'socket.io-client';

const socketUrl = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5001';
const socketPath = process.env.REACT_APP_SOCKET_PATH || '/api/socket.io/';

export const socket = io(socketUrl, {
  path: socketPath,
  transports: ['websocket', 'polling'],
  upgradeTimeout: 30000,
  timeout: 10000,
  forceNew: true,
  reconnection: true,
  reconnectionAttempts: parseInt(process.env.REACT_APP_MAX_RECONNECT_ATTEMPTS) || 5,
  reconnectionDelay: parseInt(process.env.REACT_APP_RECONNECTION_DELAY) || 1000,
  reconnectionDelayMax: parseInt(process.env.REACT_APP_RECONNECTION_DELAY_MAX) || 5000,
  maxReconnectionAttempts: parseInt(process.env.REACT_APP_MAX_RECONNECT_ATTEMPTS) || 5,
});
